import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';

export interface InvoiceCcVendor {
    vendorID: number;
    name: string;
    searchName: string;
}

export const useGetInvoiceCcVendors = (enabled = true) => {
    const sessionContext = useContext(SessionContext);
    const sessionId = sessionContext?.sessionId ?? null;

    return useQuery({
        queryKey: ['invoice-cc-vendors', sessionId],
        enabled: enabled && !!sessionId,
        retry: 1,
        queryFn: async (): Promise<InvoiceCcVendor[]> => {
            const res = await axios.post(
                `${API_URL}/invoice/cc-vendors`,
                {},
                {
                    headers: { Authorization: sessionId ?? '' },
                    validateStatus: () => true,
                }
            );
            if (res.status !== 200) {
                const msg =
                    (typeof res.data?.details === 'string' && res.data.details) ||
                    (typeof res.data?.error === 'string' && res.data.error) ||
                    (typeof res.data?.message === 'string' && res.data.message) ||
                    `Failed to load credit card vendors (HTTP ${res.status})`;
                throw new Error(msg);
            }
            const vendors = (res.data as { vendors?: InvoiceCcVendor[] })?.vendors;
            return Array.isArray(vendors) ? vendors : [];
        },
        staleTime: 5 * 60 * 1000,
    });
};
